/* Decorative interaction only. Cart and checkout keep their existing handlers. */
(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  let paused = motion.matches;
  function updateMotion() {
    document.body.classList.toggle('mh-paused', paused);
    document.querySelectorAll('[data-mh-motion]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Activar movimiento' : 'Pausar movimiento';
    });
  }
  function initialize(root) {
    root.querySelectorAll('[data-mh-hero]').forEach(hero => {
      if (hero.dataset.mhReady) return;
      hero.dataset.mhReady = 'true';
      const button = hero.querySelector('[data-mh-motion]');
      const art = hero.querySelector('[data-mh-tilt]');
      button?.addEventListener('click', () => { paused = !paused; updateMotion(); });
      hero.addEventListener('pointermove', event => {
        if (paused || motion.matches || !finePointer.matches || !art) return;
        const rect = hero.getBoundingClientRect();
        art.style.setProperty('--mh-x', `${((event.clientX - rect.left) / rect.width - .5) * 12}px`);
        art.style.setProperty('--mh-y', `${((event.clientY - rect.top) / rect.height - .5) * 8}px`);
      }, { passive: true });
      hero.addEventListener('pointerleave', () => {
        art?.style.setProperty('--mh-x', '0px');
        art?.style.setProperty('--mh-y', '0px');
      });
    });
    updateMotion();
  }
  motion.addEventListener('change', () => { paused = motion.matches; updateMotion(); });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize(document);
})();

/* Explicit optional addition; never adds automatically. */
(() => {
  let busy = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-mh-add]');
    if (!button || busy) return;
    event.preventDefault();
    busy = true;
    button.disabled = true;
    const status = button.closest('.mh-cart-extra').querySelector('[data-mh-cart-status]');
    status.textContent = 'Añadiendo ' + (button.dataset.mhName || 'producto') + '…';
    const root = window.Shopify?.routes?.root || '/';
    const drawer = button.closest('cart-drawer');
    let added = false;
    try {
      // Recheck cart: prevents duplicate offers left open in another view.
      const currentResponse = await fetch(root + 'cart.js');
      if (!currentResponse.ok) throw new Error('cart');
      const current = await currentResponse.json();
      if (current.items.some(item => String(item.variant_id) === button.dataset.mhAdd)) {
        window.location.assign(root + 'cart'); return;
      }
      const sections = drawer?.getSectionsToRender().map(section => section.id);
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: Number(button.dataset.mhAdd), quantity: 1}],
          ...(sections ? {sections, sections_url: window.location.pathname} : {})})
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        status.textContent = result.description || 'No se ha podido añadir. Revisa la disponibilidad en la ficha.';
        return;
      }
      added = true;
      if (drawer && sections.every(id => result.sections?.[id])) {
        drawer.renderContents(result);
      } else window.location.assign(root + 'cart');
    } catch (error) {
      // Never repeat an uncertain POST automatically.
      if (added) window.location.assign(root + 'cart');
      else status.textContent = 'Comprueba tu carrito antes de volver a intentarlo.';
    } finally { busy = false; button.disabled = false; }
  });
})();
